import React, { useState, useEffect } from 'react'
import './Header.scss'
import MenuMain from './MenuMain'
import BlurOverlay from './BlurOverlay'
import logo from '../assets/images/techtonic-logo.png'

const Header = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  const [menuOpen, setMenuOpen] = useState(false)
  const stateHamburgerClasses = menuOpen ? 'close' : ''
  const [screen, setScreen] = useState('desktop')
  const [mobileTalkButton, setMobileTalkButton] = useState(false)

  const handleWindowResize = () => {
    if (window.innerWidth < 768) {
      setScreen('mobile')
    } else if (window.innerWidth >= 768 && window.innerWidth <= 980) {
      setScreen('tablet')
    } else if (window.innerWidth > 980) {
      setScreen('desktop')
    }
  }
  useEffect(() => {
    handleWindowResize()
    window.addEventListener('resize', didScroll, true)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', didScroll, true)
    return () => window.removeEventListener('scroll', didScroll)
  }, [])

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const pageUrl = window.location.pathname

  const didScroll = (event) => {
    setMobileTalkButton(true)
  }

  return (
    <>
      <BlurOverlay isOverlayOpen={menuOpen} section={'menuMain'}></BlurOverlay>
      <header id="js-header">
        <div className="container">
          <div className="header-left">
            <a href="/" className="logo">
              <img src={logo} />
              <span>Software Contractors</span>
            </a>
          </div>

          <div className="header-middle">
            <div className='text-contact'>
              <a href="tel:+44 161 726 5172"><i className="fa fa-phone" aria-hidden="true"></i>+44 161 726 5172</a>
              <a href="mailto:office@techtonic-contractors.com"><i className="fa fa-envelope" aria-hidden="true"></i>office@techtonic-contractors.com</a>
            </div>
            <div className='icons-contact'>
              <a href="tel:+44 161 726 5172"><i className="fa fa-phone" aria-hidden="true"></i></a>
              <a href="mailto:office@techtonic-contractors.com"><i className="fa fa-envelope" aria-hidden="true"></i></a>
            </div>
            <MenuMain isMenuOpen={menuOpen} pagePoint={pageUrl} />
          </div>

          <div className="header-right">
            <div className={`talk-button-holder ${screen === 'mobile' && mobileTalkButton === true ? 'mobile-on' : '' && pageUrl !== '/contact' ? 'mobile-on' : ''}`}>
              <a href="/contact"
                 className={`button ${menuOpen ? 'inverted' : ''}`}>
                <i className="fa fa-link" aria-hidden="true"></i>Let's Talk</a>
            </div>

            <div className="hamburger-holder">
              <div
                id="hamburger"
                className={stateHamburgerClasses}
                onClick={toggleMenu}
                aria-label="Toggle menu">
                <span className="top"></span>
                <span className="middle"></span>
                <span className="bottom"></span>
              </div>
            </div>

          </div>
        </div>
      </header>
    </>
  )
}

export default Header